import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Modal} from 'components/ui';
import {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import styles from './LogoutModal.module.scss';

function LogoutModal(): JSX.Element {
  const [isVisible, setIsVisible] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.addEventListener('invalidAuth', (event) => handleInvalidAuth(event));

    return () => {
      window.removeEventListener('invalidAuth', (event) =>
        handleInvalidAuth(event),
      );
    };
  }, []);

  function handleInvalidAuth(event: CustomEvent) {
    setIsVisible(event.detail === 'invalid');
  }

  function handleCloseClick() {
    setIsVisible(false);
    navigate('/login');
  }

  return (
    <Modal
      isOpen={isVisible && location.pathname !== '/login'}
      clickOutsideToClose={false}
      onClose={() => handleCloseClick()}
    >
      <div className={styles.container} data-testid="logout-modal">
        <h2 className={styles.title}>
          Sua sessão foi encerrada automaticamente.
        </h2>

        <FontAwesomeIcon
          className={styles.icon}
          icon={['fad', 'users-slash']}
        />

        <p className={styles.message}>
          Suas atividades foram salvas,
          <br /> para continuar faça login novamente.
        </p>

        <Button
          text="Sair"
          variant="secondary"
          leftIcon={{icon: 'sign-out-alt'}}
          onClick={() => handleCloseClick()}
        />
      </div>
    </Modal>
  );
}

export default LogoutModal;
